import React, { useState, useEffect } from "react"

import ReactPlayer from "react-player"

import { Link } from "gatsby"

import ProdhostButton from "../../Button/Button"

import appstore from "../../../assets/images/appstore.png"
import googleplay from "../../../assets/images/googleplay.png"
import microsoft from "../../../assets/images/microsoft.png"

import { LazyLoadComponent } from "react-lazy-load-image-component"

import "./mainCarouselItem.scss"

function getWindowDimensions() {
  if (typeof window !== "undefined") {
    const { innerWidth: width, innerHeight: height } = window
    return {
      width,
      height,
    }
  } else {
    return {
      width: 0,
      height: 0,
    }
  }
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  )

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return windowDimensions
}

const CarouselItem = (props) => {
  const { height, width } = useWindowDimensions()

  return (
    <LazyLoadComponent>
      <div
        className="carousel-item-wrapper"
        style={
          width < 1280
            ? {
                background: `url(${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${props.background_picture.path})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }
            : null
        }
      >
        <div className="main_container">
          <h1
            id="prodhost_title"
            dangerouslySetInnerHTML={{ __html: props.item.value.wysiwyg_title }}
          ></h1>
          <h2 className="description">{props.item.value.text_descr}</h2>
          <div className="buttons">
            {props.item.value.bool_downloadable ? (
              <div className="downloads">
                <a
                  href={"https://apps.apple.com/"}
                  rel={"noopener noreferrer"}
                  target={"_blank"}
                >
                  <img src={appstore} alt="appstore_logo" />
                </a>
                <a
                  href={"https://play.google.com/"}
                  rel={"noopener noreferrer"}
                  target={"_blank"}
                >
                  <img src={googleplay} alt="googleplay_logo" />
                </a>
                <a
                  href={
                    "https://www.microsoft.com/hu-hu/p/prodhost/9plgkbl0ldwm?rtc=1&activetab=pivot:overviewtab"
                  }
                  rel={"noopener noreferrer"}
                  target={"_blank"}
                >
                  <img src={microsoft} alt="microsoft_logo" />
                </a>
                <a
                  href={"https://apps.apple.com/"}
                  rel={"noopener noreferrer"}
                  target={"_blank"}
                ></a>
              </div>
            ) : (
              <>
                {props.item.value.text_red_button_label ? (
                  <Link to={props.item.value.text_red_button_url}>
                    <ProdhostButton
                      type="primary"
                      text={props.item.value.text_red_button_label}
                    />
                  </Link>
                ) : null}
                {props.item.value.text_gray_button_label ? (
                  <Link to={props.item.value.text_gray_button_url}>
                    <ProdhostButton
                      type="primary"
                      model="2"
                      text={props.item.value.text_gray_button_label}
                    />
                  </Link>
                ) : null}
              </>
            )}
          </div>
        </div>
        {width >= 1280 && width !== 0 ? (
          <div className="background_video">
            <ReactPlayer
              url={props.item_video}
              width={"100%"}
              height={"100%"}
              playing={props.activeSlide === props.activeSlide2 ? true : false}
              muted
              loop
            />
          </div>
        ) : null}
      </div>
    </LazyLoadComponent>
  )
}

export default CarouselItem
